import styled from 'styled-components';
import { pxToRem } from 'utils/scss';

export const PopupWrapper = styled.div`
  position: absolute;
  right: -${pxToRem('10px')};
  top: ${pxToRem('100px')};
  width: ${pxToRem('220px')};
  height: auto;
  border-radius: ${pxToRem('8px')};
  box-shadow: 0 ${pxToRem('12px')} ${pxToRem('24px')} ${pxToRem('8px')}
    ${props => props.theme.colors.blue.six};
  border: solid ${pxToRem('1px')} ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  z-index: 100;
  justify-content: space-around;
  margin-right: ${pxToRem('40px')};
  padding: ${pxToRem('20px')};
`;

export const ListItem = styled.div`
  padding: ${pxToRem('15px')};
  text-align: center;
  border-radius: ${pxToRem('10px')};
  display: flex;
  font-weight: 500;
  justify-content: flex-start;
  :hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.blue.five};
    font-weight: 600;
  }
  gap: ${pxToRem('20px')};
  align-items: center;
  text-transform: capitalize;
`;

export const FlagImage = styled.img`
  width: 20%;
  height: auto;
`;
